// app/javascript/controllers/user_grid_controller.js

import { Controller } from "stimulus"
import { createRoot } from 'react-dom/client'
import React from 'react'
import {ProfileDetailView} from '../components/profiles/ProfileViews' // Adjust path as needed

export default class extends Controller {
  // Define the target for the mount point
  static targets = ["mount"]
  
  // Set the mount point for React rendering
  connect() {
    console.log('profile_modal_controller:connect')
    this.mountPoint = document.getElementById('profile_detail_view_modal_id');
  }

  showDetail(event) {
    console.log('profile_modal_controller:showDetail')
    // 1. Stop the browser from following any link/default action
    event.preventDefault();
    this.root = createRoot(this.mountPoint);

    // 2. Get the user data from the clicked element's data attribute
    // event.currentTarget is the element that has the data-action
    const project_id = event.currentTarget.dataset.project_id;
    const project_folder_id = event.currentTarget.dataset.project_folder_id;
    const userUuid = event.currentTarget.dataset.userUuid;
    let user = undefined;
    if(userUuid == undefined) {
        const userDataJson = event.currentTarget.dataset.userData;
        if (!userDataJson) {
          console.error("User data not found on element.");
          return;
        }
        // Parse the JSON string back into a JavaScript object
        user = JSON.parse(userDataJson);
    }
    let currentUser = undefined;
      const userDataJson = event.currentTarget.dataset.currentUserData;
      if (!userDataJson) {
        console.error("User data not found on element.");
        return;
      }
      currentUser = JSON.parse(userDataJson);
      console.log('currentUser', currentUser);
  
    if((userUuid == undefined && user == undefined) || (user !== undefined && user.first_name == null)) {
      return;
    }
    // 3. Render the React component with the user data
    this.root.render(
    <ProfileDetailView user={user} 
    currentUser={currentUser} 
      userUuid={userUuid}
      project_id={project_id} 
      onClose={this.handleReactUpdate.bind(this)} 
      project_folder_id={project_folder_id}
       />
    );

    // 4. Show the mount point (e.g., by removing the 'hidden' class)
    this.mountPoint.classList.remove('hidden'); 
    
    // Optional: Scroll to the details view or show a modal
    // this.mountPoint.scrollIntoView({ behavior: 'smooth' });
  }


  handleReactUpdate() {
    console.log('profile_modal_controller:handleReactUpdate')
    if (this.root) {
      this.root.unmount();
    }

  }


  // Cleanup when the controller is disconnected (optional)
  disconnect() {
    console.log('profile_modal_controller:disconnect')
    if (this.root) {
      this.root.unmount();
    }
  }
}